import React, { useState } from "react"

import { ToggleTagRefinementItem } from "components/page-components/Internal-Search/utils"
import { connectRefinementList } from "react-instantsearch-dom"

export const TagRefinement = connectRefinementList(
  ({ items, refine, searchState, showMoreIncrements }) => {
    const [current_limit, set_current_limit] = useState(showMoreIncrements)
    const [show_all, set_show_all] = useState(false)

    const has_more =
      items.filter(({ label }) => !!label)?.length > current_limit

    const get_display_tags = () => {
      const display_items = items
        .filter(({ label }) => !!label)
        .slice(0, current_limit)
      if (!show_all) {
        return display_items
      }
      display_items.sort((a, b) => a.label.localeCompare(b.label))
      return display_items
    }
    const display_tags = get_display_tags()
    const all_refinded = display_tags.every(({ isRefined }) => !!isRefined)

    const increase_limit = () => {
      set_current_limit(items.length + 1)
      set_show_all(true)
    }
    const reset_limit = () => {
      set_current_limit(showMoreIncrements)
      set_show_all(false)
    }

    return (
      <React.Fragment>
        <div className="field is-grouped is-grouped-multiline is-flex">
          {display_tags?.map(({ label, isRefined }) => {
            return (
              <div className="control" key={`type_refinement-${label}`}>
                <div className="tags has-addons internal-search-tags are-medium is-clickable">
                  <ToggleTagRefinementItem
                    {...{
                      label,
                      refine,
                      isRefined: isRefined && !all_refinded,
                      searchState,
                    }}
                  />
                </div>
              </div>
            )
          })}
          {has_more ? (
            <div className="control is-flex">
              <a
                href={"# "}
                onClick={increase_limit}
                className="ml-3 my-auto link has-text-white"
              >
                mehr...
              </a>
            </div>
          ) : show_all ? (
            <div className="control is-flex">
              <a
                href={"# "}
                onClick={reset_limit}
                className="ml-3 my-auto link has-text-white"
              >
                weniger...
              </a>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    )
  }
)
